
import { defineComponent } from "vue"

export default defineComponent({
	props: {
		name: String,
		placeholder: String,
		modelValue: String
	}
})
